import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  OnDestroy,
  ViewChildren,
  HostListener,
  ElementRef,
  TemplateRef,
  Renderer2,
  Output,
  EventEmitter,
  Inject
} from '@angular/core';
import {UserGroupService} from 'src/app/core/services/user-group.service';
import {MatDialogRef, MatDialog, MatExpansionPanel, MatSelect, MAT_DIALOG_DATA} from '@angular/material';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {ReplaySubject, Subject, Subscription} from 'rxjs';
import {FormControl, NgForm} from '@angular/forms';
import {NotificationService} from 'src/app/core/services/notification.service';
import {first, map, takeUntil} from 'rxjs/operators';
import {DeactivationGuarded} from 'src/app/core/guards/confirm-deactivate.guard';
import {Message} from 'src/app/core/class/message';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from 'src/app/core/services/api.service';
import {CommonService} from 'src/app/core/services/common.service';
import {AutoDepartmentFilterService} from 'src/app/core/services/auto-department-filter.service';
import {SCREEN_SIZE} from 'src/app/core/constants/screen-size';
import {DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable} from 'rxjs';
import {DepartmentService} from '../../../../../../../core/services/department.service';
import {ErrorCode} from 'src/app/core/constants/error-code';

@Component({
  selector: 'app-add-user-department',
  templateUrl: './add-user-department.component.html',
  styleUrls: ['./add-user-department.component.scss']
})
export class AddUserDepartmentComponent implements OnInit {
  isShowResult = false;
  listErrorUser = [];
  countSuccess = 0;
  countError = 0;
  isSavingData = false;
  inputUserValue: string;
  filteredUserOptions = [];
  dataSource: DocumentDataSource;
  firstEditLoaded = true;
  listUserInDepartment = [];
  userGroup = {
    idString: null,
    code: '',
    name: '',
    description: '',
    listUserInDepartment: [],
    representativeIdString: '',
  };
  change = false;
  featuresGroups: any;
  features: any;
  dataRole: any;
  subSignPermission: any;
  subManagerPermission: any;
  checkEscKey = false;
  checkAll = false;
  isFormChanging = false;
  formChangesSubscription: Subscription;
  grIdDefualt = {
    managerServiceTypeFeatureGroupId: '',
    signServiceTypeFeatureGroupId: ''
  };
  grId = this.grIdDefualt;
  nzCheckLoadingUser = false;
  isMultiCreateUserGroup = false;
  urlApi = '/users/group-user';
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('statusSelect', {static: false}) statusSelect: MatSelect;
  checkFocus = true;
  serviceTypes: comboBox[] = [];
  isServiceTypesLoading = false;
  serviceTypePermission;
  showCreateSideError = false;
  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  selectedDocumentTypeParent: { id: string, fullName: string, email?: string, filePath?: string };
  serviceTypesFilterCtrl: FormControl = new FormControl();
  private _onDestroy = new Subject<void>();
  displayItem = (x: any) => x !== null ? x.fullName !== undefined ? x.fullName + ' - ' + x.email : '' : '';
  columnDefinitions = [
    {def: 'fullName', showXS: true, showSM: true, showMD: true},
    {def: "action", showXS: true, showSM: true, showMD: true}
  ];

  displayedColumns: string[] = [];
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  columnDefinitionsResult = [
    {def: 'fullName', showXS: true, showSM: true, showMD: true},
    {def: 'description', showXS: true, showSM: true, showMD: true},
  ];
  displayedColumnsResult: string[] = [];

  @ViewChild('customPanel', {static: false}) panel: MatExpansionPanel;
  @ViewChild('togglePanelButton', {static: false}) togglePanelButton: ElementRef;
  @ViewChild('f', {static: false}) ngForm: NgForm;
  @ViewChildren('focusInput') focusInput;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event) {
    if (!this.checkEscKey) {
      this.onClickBtnCancel();
    }
  }

  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  constructor(
    private apiService: ApiService,
    private el: ElementRef,
    private sv: UserGroupService,
    private dialogRef: MatDialogRef<AddUserDepartmentComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
    public commonService: CommonService,
    private renderer: Renderer2,
    public autoDepartmentFilterService: AutoDepartmentFilterService,
    private departmentService: DepartmentService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onClickBtnCancel();
    });
    this.getDisplayedColumns();
    this.getDisplayedColumnsResult();
  }

  ngOnInit() {
    this.userGroup.idString = this.data.idString;
    this.dataSource = new DocumentDataSource();
    this.apiService.addUrlToHandlingErrorRestApis(this.urlApi);
    this.loadGrId();
    this.loadFuture();

    this.serviceTypesFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(
        () => {
          this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypesFilterCtrl, this.filteredServiceTypes);
        });

    this.getServiceTypeByEnterprise();
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
      }

    }
  }

  closeDialog() {
    this.dialogRef.close(true)
  }


  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
    this.apiService.removeUrlToHandlingErrorRestApis();
  }

  // Định dạng bảng trong kết quả trả về
  getDisplayedColumnsResult() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumnsResult = this.columnDefinitionsResult
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumnsResult = this.columnDefinitionsResult
          .filter(cd => cd.showMD)
          .map(cd => cd.def);
      } else {
        this.displayedColumnsResult = this.columnDefinitionsResult.map(cd => cd.def);
      }

    }
  }

  /**
   * Create group user
   */
  onCreateGroup() {
    // Chặn click liên tục
    if (this.isSavingData) {
      return;
    }
    this.isSavingData = true;
    let listUser = [];
    this.listUserInDepartment.forEach(item => {
      listUser.push(item.id);
    });
    this.userGroup.listUserInDepartment = listUser;
    if (this.userGroup.representativeIdString === undefined) {
      this.userGroup.representativeIdString = null;
    }
    // check in list user?
    if (this.userGroup.representativeIdString !== null) {
      let isExist = false;
      this.listUserInDepartment.forEach(item => {
        if (item.id === this.userGroup.representativeIdString) {
          isExist = true;
        }
      });
      if (!isExist) {
        this.userGroup.representativeIdString = null;
      }

    }
    this.departmentService.updateUserInDepartment(this.userGroup).subscribe(res => {
      if (res.success) {
        if (this.userGroup.listUserInDepartment.length > 0 && res.data.successCount === this.userGroup.listUserInDepartment.length) {
          // Nếu danh sách user đúng hết
          this.toastr.success(this.message.getMessage('messages.add_user_department'));
          this.dialogRef.close();
        } else if (this.userGroup.listUserInDepartment.length > 0 && res.data.successCount > 0 && res.data.successCount !== this.userGroup.listUserInDepartment.length) {
          // Nếu danh sách user đúng 1 phần
          this.toastr.success(this.message.getMessage('messages.add_user_department'));
          this.isShowResult = true;
          this.countSuccess = res.data.successCount;
          this.countError = res.data.listUserError.length;
          this.listErrorUser = res.data.listUserError;
        } else if (this.userGroup.listUserInDepartment.length > 0 && res.data.successCount === 0) {
          // User sai hết
          this.toastr.error(this.message.getMessage('messages.add_user_department_error'));
          this.isShowResult = true;
          this.countSuccess = res.data.successCount;
          this.countError = res.data.listUserError.length;
          this.listErrorUser = res.data.listUserError;
        }

      } else if (res.code === ErrorCode.DataNotfound) {
        this.toastr.error(this.message.getMessage('messages.add_user_department_not_found'));
        this.dialogRef.close();
      } else if (res.code === ErrorCode.DepartmentDeletedOrLocked) {
        this.toastr.error(this.message.getMessage('messages.add_user_department_inactive'));
        this.dialogRef.close();
      } else if (res.code === ErrorCode.ContactSystemAdmin) {
        this.toastr.error(this.message.getMessage(res.message));
        this.dialogRef.close();
      } else {
        this.isSavingData = false;
        this.toastr.error(this.message.getMessage('messages.add_user_department_error'));
        this.dialogRef.close();
      }
    }, err => {
      this.isSavingData = false;
    });

    // this.userGroup.featureGroupIds = this.getPermission();
    // this.userGroup.managerPermissionServiceType = this.getManagerPermissionServiceType();
    // this.userGroup.signPermissionServiceTypes = this.getSubSignPermission();
    // this.sv.addUserGroup(this.userGroup, this.onAddUserGroupError.bind(this)).subscribe(rs => {
    //   if (rs.success) {
    //     this.toastr.success(this.message.getMessage('messages.add_success'));
    //     if (this.isMultiCreateUserGroup) {
    //       this.loadFuture();
    //       this.ngForm.resetForm();
    //       setTimeout(_ => this.focusInput.first.nativeElement.focus());
    //       this.isFormChanging = false;
    //     } else {
    //       this.dialogRef.close();
    //     }
    //   }
    // });
  }

  getManagerPermissionServiceType(): any[] {
    // console.log('service type permission o day', this.serviceTypePermission);
    return this.serviceTypePermission;
  }

  private onAddUserGroupError(rs: any) {

    if (!rs.success) {
      if (rs.code == '0x00604') {
        this.ngForm.form.controls.name.setErrors({invalid: true, duplicate: true});
        document.getElementById('name').focus();
      }
    }
  }

  /**
   * Get permission
   */
  private getPermission() {
    let tempRole: any;
    tempRole = this.dataRole.filter(role => {
      return role.active;
    });
    tempRole = tempRole.map(item => {
      return item.id;
    });
    return tempRole;
  }

  /**
   * Load all feature from server
   */
  async loadFuture() {
    this.features = await this.sv.getAllFeatures().toPromise();
    this.featuresGroups = await this.sv.getAllFeaturesGroups().toPromise();
    this.subSignPermission = await this.sv.getServiceType(localStorage.getItem('enterpriseId')).toPromise();
    this.mapGroupUser();
  }

  /**
   * Load all feature from server
   */
  loadGrId() {
    this.sv.getFeatureGrId().subscribe(rs => {
      if (rs && rs.data != null) {
        this.grId = rs.data;
      }
    });
  }

  /**
   * Map feature to show
   */
  mapGroupUser() {
    if (this.featuresGroups.data != null) {
      let isParentEnterprise = localStorage.getItem('isParent');
      this.dataRole = this.featuresGroups.data.map(feGr => {
        feGr.active = false;

        if (feGr.id === this.grId.signServiceTypeFeatureGroupId && this.subSignPermission
          && this.subSignPermission.data && this.subSignPermission.data.length > 0) {
          feGr.subSignPermission = this.subSignPermission.data.map(sub => {
            return sub;
          });
        }

        feGr.child = this.features.data.filter(fe => {
          if (fe.code !== 'ae.qlttnd.cnttdn') {
            if (isParentEnterprise) {
              return fe.featureGroupId === feGr.id;
            } else {
              if (fe.code !== 'ae.qlttdn.qlttcn' && fe.code !== 'ae.qlttdn.qlldv') {
                return fe.featureGroupId === feGr.id;
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        });
        return feGr;
      }).filter(r => r.code !== 'ae.qldmtl' && r.code !== 'ae.kstl');
      let createSideFeGrIndex = -1;
      let receiveSideFeGrIndex = -1;
      this.dataRole.forEach((feGr, index) => {
        if (feGr.code === 'ae.qlhdct') {
          createSideFeGrIndex = index;
        }
        if (feGr.code === 'ae.qlhddt') {
          receiveSideFeGrIndex = index;
        }
      })
      if (createSideFeGrIndex > -1 && receiveSideFeGrIndex > -1) {
        const tempFeGr = this.dataRole[createSideFeGrIndex];
        this.dataRole[createSideFeGrIndex] = this.dataRole[receiveSideFeGrIndex];
        this.dataRole[receiveSideFeGrIndex] = tempFeGr;
      }
    }
  }

  /**
   * Handle when click check all icon
   */
  checkAllRole() {
    this.dataRole.map(roleGr => {
      this.checkAll ? roleGr.active = true : roleGr.active = false;
      return roleGr;
    });
  }

  /**
   * Handle when click check all icon
   */
  checkAllPermission() {
    this.dataRole.map(item => {
      item.active = this.checkAll;
      if (item.subSignPermission) {
        item.subSignPermission.map(subitem => subitem.active = this.checkAll);
      }

      return item;
    });
  }

  /**
   * Event when click button cancel
   */
  onClickBtnCancel() {
    if ((this.isFormChanging || this.change) && this.listUserInDepartment.length > 0) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    if (!this.isFormChanging) {
      return true;
    } else {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    }
  }

  /**
   * Event handle check/uncheck sub permission
   */
  permissionChanged(id: string) {
    const permission = this.dataRole.find((item: { id: string; }) => item.id === id);
    if (id === this.grId.signServiceTypeFeatureGroupId && permission.subSignPermission != undefined) {
      permission.subSignPermission.map((item: { active: boolean; }) => {
        permission.active ? item.active = true : item.active = false;
      });
    }
    if (permission.code === 'ae.qlhdct') {
      this.serviceTypePermission = []
    }

    this.verifyCheckAllStage();
  }

  /**
   * Event handle check/uncheck parent sign permission
   */
  subSignChange(group: any) {
    group.active = group.subSignPermission.every((item: { active: any }) => {
      return item.active;
    });
    this.verifyCheckAllStage();
    this.change = true;
  }

  verifyCheckAllStage() {
    this.checkAll = this.dataRole.every((item: { active: any; }) => {
      return item.active;
    });
    this.change = true;
  }

  /**
   * Get sub permission for sign document
   */
  private getSubSignPermission() {
    let tempRole: any;
    this.dataRole.map(x => {
      if (x.id === this.grId.signServiceTypeFeatureGroupId && x.subSignPermission) {
        tempRole = x.subSignPermission.filter(rs => {
          return rs.active;
        });
        tempRole = tempRole.map(item => {
          return item.id;
        });
        return tempRole;
      } else {
        tempRole = [];
      }
    });
    return tempRole;
  }

  getServiceTypeByEnterprise() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.isServiceTypesLoading = true;
    this.commonService.getEnterpriseServiceType(enterpriseId).subscribe(rs => {
      this.isServiceTypesLoading = false;
      if (rs && rs.data) {
        this.serviceTypes = rs.data;
        this.filteredServiceTypes.next(rs.data.slice());
        /* set gias tri service type */
        // this.serviceTypePermission = parseInt(this.serviceTypePermission);
      }
    }, () => this.isServiceTypesLoading = false);
  }

  updateServiceTypePermission(serviceTypePermission: any[]) {
    if (serviceTypePermission != null) {
      this.serviceTypePermission = [...serviceTypePermission];
      if (this.serviceTypePermission.length > 0) this.showCreateSideError = false;
    }
  }

  togglePanel() {
    this.panel.toggle();
    this.renderer.setStyle(this.togglePanelButton.nativeElement, 'transform', `rotate(${this.panel.expanded ? '180' : '0'}deg)`)
  }

  /* If select create side contract permission then required at least 1 service type selected */
  checkCreateSideValid() {
    const createSidePermissionSelected = this.dataRole.find(fGr => fGr.active === true && fGr.code === 'ae.qlhdct');
    const serviceTypeId = this.getManagerPermissionServiceType();
    return !(createSidePermissionSelected && serviceTypeId.length === 0)
  }

  public onChangeAutoCompletedDocumentTypeParent() {
    // if (this.selectedDocumentTypeParent === null || this.selectedDocumentTypeParent === undefined) {
    //   this.userGroup.name = null;
    //   this.selectedDocumentTypeParent = null;
    //   this.setFormChanging(true);
    // } else {
    //   this.userGroup.name = this.selectedDocumentTypeParent.id;

    //   if (!this.firstEditLoaded) {
    //     this.setFormChanging(true);
    //   }
    // }
    if (this.selectedDocumentTypeParent !== null && this.selectedDocumentTypeParent !== undefined) {
      let isChoosed = false;
      this.listUserInDepartment.forEach(item => {
        if (item.id === this.selectedDocumentTypeParent.id) {
          isChoosed = true;
        }
      });
      if (!isChoosed) {
        this.listUserInDepartment.push(this.selectedDocumentTypeParent)
        // this.selectedDocumentTypeParent = null;
      }
    }
  }

  // Function handler set sự thay đổi trên form.
  setFormChanging(changingStatus: boolean): void {
    this.isFormChanging = changingStatus;
    this.hasChange.emit(changingStatus);
  }

  optionSelected(data) {
    this.dataSource.setData(this.listUserInDepartment);
  }

  delete(id) {
    this.listUserInDepartment = this.listUserInDepartment.filter(item => item.id !== id);
    this.dataSource.setData(this.listUserInDepartment);
  }

  onChangeUserSignSearch(event): void {
    if (this.inputUserValue.trim().length > 0) {
      this.nzCheckLoadingUser = true;
      this.departmentService.getUserByFullNameOrEmail(this.inputUserValue.trim())
        .subscribe(result => {
          this.filteredUserOptions = result.data;
          if (this.listUserInDepartment.length > 0) {
            this.filteredUserOptions = this.filteredUserOptions.filter(item => {
              let isExist = false;
              this.listUserInDepartment.forEach(i => {
                if (item.id === i.id) {
                  isExist = true;
                }
              })
              if (!isExist) {
                return item;
              }
            });
          }
          this.nzCheckLoadingUser = false;
        }, error => {
          this.nzCheckLoadingUser = false;
        });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }

  autocompleteUserSelected($event: any, model: any) {
    if ($event.isUserInput) {
      this.isFormChanging = true;
      const duplicateItem = this.listUserInDepartment.find(item => item.id === model.id);
      if (!duplicateItem || duplicateItem.length === 0) {
        this.listUserInDepartment.push(model);
      }
    }
  }

  deleteCertificate(username) {
    this.isFormChanging = true;
    this.listUserInDepartment = this.listUserInDepartment.filter(v => v.id !== username.id);
    if (username.id === this.userGroup.representativeIdString) {
      this.userGroup.representativeIdString = null;
    }
    console.log(this.listUserInDepartment)
  }
}


export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  constructor() {
    super();
  }


  setData(data: Document[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }

  representativeSelected(data) {
  }

}
